module.exports = __webpack_public_path__ + "img/arrow-up-triangle-square.49813fa6.svg";